export enum HomeRoutesNamesEnum {
  home = 'home',
  homeProjects = 'home-projects',
  drafts = 'drafts',
  templates = 'templates',
  clients = 'clients',
  chats = 'chats'
}
